// extracted by mini-css-extract-plugin
module.exports = {"choice":"choice_choice__3bvLl"};